module.exports = __webpack_public_path__ + "img/creativo-speciaux.b65da4e0.jpg";